import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import downArrowSmall from "svg/downArrowSmall.svg";
import upArrowSmall from "svg/upArrowSmall.svg";
import downArrowLarge from "svg/downArrowLarge.svg";
import upArrowLarge from "svg/upArrowLarge.svg";
import "./style.scss";

const SelectInput = ({
  label,
  handleSelectInput,
  value,
  disabled = false,
  options = [],
  defaultValue = "",
  showEmptyValue = false,
  type = "__drop-down",
  inputRef,
  id = "",
  isRequired = false,
  errorMsg,
  isPrc,
  isJob,
  isNA,
  isProg,
  isProjName,
  projClass,
  errStyle,
}) => {
  const [displayOptions, setDisplayOptions] = useState(false);
  let dropdownOptions = [...options];
  if (!showEmptyValue)
    if (isPrc) {
      dropdownOptions = [
        {
          prcNbr: "",
          descr: isNA ? "None Available" : "-- Select value --",
        },
        ...options,
      ];
    } else if (isJob) {
      dropdownOptions = [
        {
          jobNbr: isNA ? "None Available" : "-- Select value --",
          jobName: "",
        },
        ...options,
      ];
    } else if (id === "department") {
      dropdownOptions = [
        {
          id: null,
          description: "All Departments",
        },
        ...options,
      ];
    } else if (id === "category") {
      dropdownOptions = [
        {
          id: null,
          description: "All Categories",
        },
        ...options,
      ];
    } else if (id === "progCategory") {
      dropdownOptions = [
        {
          categoryId: "",
          typeId: "",
          name: "-- Select value --",
        },
        ...options,
      ];
    } else {
      dropdownOptions = [
        {
          id: null,
          label: "-- Select value --",
          description: "-- Select value --",
        },
        ...options,
      ];
    }

  useEffect(() => {
    let closeDropDownHandler = (event) => {
      if (
        inputRef &&
        inputRef.current &&
        inputRef.current != null &&
        event &&
        event.target &&
        event.target != null &&
        !inputRef.current.contains(event.target)
      ) {
        setDisplayOptions(false);
      }
    };
    document.addEventListener("mousedown", closeDropDownHandler);
    return () => {
      document.removeEventListener("mouse", closeDropDownHandler);
    };
  });

  const handleDisplayOptions = () => {
    setDisplayOptions((current) => !current);
  };
  const handleClick = (e, option) => {
    setDisplayOptions((current) => !current);
    handleSelectInput(e, option);
  };
  const getOptions = () => {
    return (
      dropdownOptions &&
      dropdownOptions.map((option, index) => {
        return (
          <div id={id} className="select__dropdown__list--option" key={index} onClick={(e) => handleClick(e, option)}>
            {isPrc
              ? option.prcNbr
                ? option.prcNbr + " : " + option.descr
                : option.descr
              : isJob
                ? option.jobName && option.jobNbr
                  ? option.jobNbr + " : " + option.jobName
                  : option.jobNbr
                : id === "progCategory"
                  ? option.name
                  : option.description}
          </div>
        );
      })
    );
  };
  const dropdownValue = value && value != null && value !== "" ? value : defaultValue;
  const fieldClassName = "select__dropdown__field" + type;
  const inputClassName = fieldClassName + "__input";
  const inputClassNameText = inputClassName + "--text";
  const inputClassNameIcon = fieldClassName + "--icon";
  const downArrowIcon = type === "__pagination" ? downArrowSmall : downArrowLarge;
  const upArrowIcon = type === "__pagination" ? upArrowSmall : upArrowLarge;

  return (
    <div className="form-group select-wrapper">
      {label !== "" && label != null && (
        <label className={`select__label ${isRequired ? "required" : ""}`}>{label}</label>
      )}
      <div id="custom-dropdown" ref={inputRef} className="select__dropdown">
        <div className={`${fieldClassName}`}>
          <Button
            variant="outline"
            className={`${isProjName ? projClass : `form-control ${inputClassName} ${errorMsg ? "error-field" : ""}`} `}
            onClick={handleDisplayOptions}
            disabled={disabled}
          >
            <span
              className={`${isProjName ? "font-sty" : `${inputClassNameText}`} ${dropdownValue === defaultValue ? "defaultColor" : ""}`}
            >
              {dropdownValue}
            </span>
          </Button>
          <img
            src={displayOptions ? upArrowIcon : downArrowIcon}
            alt={"dropdown-icon"}
            className={inputClassNameIcon}
            onClick={handleDisplayOptions}
          />
        </div>
        {displayOptions && <div className="select__dropdown__list">{getOptions()}</div>}
      </div>
      {errorMsg && <span className={`error-etext error-${errStyle}`}>{errorMsg}</span>}
    </div>
  );
};

SelectInput.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  disabled: PropTypes.bool,
  handleSelectInput: PropTypes.func.isRequired,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
};

export default SelectInput;
